import { FrameService } from '~/support/services';

export default {
  async createFrame(_, payload) {
    const service = new FrameService(useRuntimeConfig().public.framesBaseUrl);
    const data = await service.createFrame(payload);

    return data;
  },

  async fetchOne(_, frameId) {
    const service = new FrameService(useRuntimeConfig().public.framesBaseUrl);
    const data = await service.fetchOne(frameId);

    return data;
  },

  async updateFrame(_, payload) {
    const service = new FrameService(useRuntimeConfig().public.framesBaseUrl);
    const data = await service.updateFrame(payload);

    return data;
  },
};
